var map = {
	"./arrow-default.svg": "219b",
	"./arrow-long.svg": "b0b5",
	"./arrow-top.svg": "f0c6",
	"./arrow.svg": "d512",
	"./car-calc.svg": "4b79",
	"./check.svg": "06f6",
	"./class.svg": "1fef",
	"./close.svg": "a2d7",
	"./compass-white.svg": "a49c",
	"./compass.svg": "c0bc",
	"./cons-1.svg": "9e98",
	"./cons-2.svg": "a4f5",
	"./cons-3.svg": "24e4",
	"./cons-4.svg": "c09c",
	"./fast-time.svg": "722b",
	"./hand-key.svg": "a702",
	"./instagram.svg": "3f07",
	"./layout-arrow.svg": "1f3c",
	"./long-arrow.svg": "994c",
	"./loop.svg": "d15c",
	"./mark-price.svg": "b8b7",
	"./mobile-notif.svg": "b9ec",
	"./people-settings.svg": "9b6f",
	"./phone-setting.svg": "8a94",
	"./scroll.svg": "44fe",
	"./star.svg": "db9f",
	"./telegram.svg": "8f34",
	"./viber.svg": "9d15",
	"./vk.svg": "8c59",
	"./wats.svg": "166a",
	"./working.svg": "7641"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7769";